<style scoped>
    .date-picker-container{
        display: inline-block;
        width: 200px;
    }
</style>
<template>
  <div>
    <Drawer
      v-model="config.modal"
      width="640"
      title="费用导出"
    >
      <div class="line text-center">
        <Select
          v-model.number="params.payment_type"
          placeholder="类型"
          style="width: 100px"
        >
          <Option :value="-1">
            全部费用类型
          </Option>
          <Option :value="1">
            付款
          </Option>
          <Option :value="0">
            报销
          </Option>
          <Option :value="2">
            预支
          </Option>
          <Option :value="3">
            充值
          </Option>
          <Option :value="5">
            计提
          </Option>
          <Option :value="6">
            计提修正
          </Option>
          <Option :value="7">
            充值冲销
          </Option>
          <Option :value="8">
            发票提交
          </Option>
          <Option :value="9">
            账单提交
          </Option>
        </Select>
        <Select
          v-model="params.time_item"
          placeholder="日期维度"
          style="width: 100px"
        >
          <Option value="created_at">
            申请时间
          </Option>
          <Option value="verified_at">
            入账会计期
          </Option>
          <Option value="paid_at">
            付款时间
          </Option>
        </Select>
        <div class="date-picker-container">
          <Date-picker
            type="daterange"
            :options="date_option"
            placement="bottom-start"
            placeholder="日期范围"
            style="width: 200px"
            @on-change="dateRangeChange"
          />
        </div>
      </div>
      <div class="line text-center">
        <Select
          v-if="companies.length"
          v-model.number="params.company_id"
          placeholder="选择公司"
          style="width: 100px"
        >
          <Option :value="0">
            所有公司
          </Option>
          <Option
            v-for="c in companies"
            :key="c.id"
            :value="c.id"
          >
            {{ c.short_name }}
          </Option>
        </Select>
        <Select
          v-if="teams.length"
          v-model.number="params.team_id"
          placeholder="团队"
          style="width: 100px"
        >
          <Option :value="0">
            所有团队
          </Option>
          <Option
            v-for="team in teams"
            :key="team.id"
            :value="team.id"
          >
            {{ team.name }}
          </Option>
        </Select>
        <Button
          type="primary"
          :loading="loading"
          @click="exportResource"
        >
          <Icon type="ios-download-outline" />
          导出
        </Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        config: {
          modal: false
        },
        params: {
          time_item: 'created_at',
          date_range: [],
          payment_type: 1,
          company_id: 0,
          team_id: 0
        },
        loading: false,
        date_option: {
          shortcuts: [
            {
              text: '最近一周',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                return [start, end];
              }
            },
            {
              text: '最近一个月',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                return [start, end];
              }
            },
            {
              text: '最近三个月',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                return [start, end];
              }
            },
            {
              text: '最近一年',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                return [start, end];
              }
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
      }),
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      show() {
        this.config.modal = true;
      },
      dateRangeChange(date_range) {
        this.params.date_range = date_range;
      },
      checkValid() {
        if (this.params.date_range.length === 0) {
          this.$Message.error({title: '提示', content: '请选择日期'});
          return false;
        }
        return true;
      },
      exportResource() {
        if (!this.checkValid()) return;
        if (this.loading) return;
        this.loading = true;
        Util.ajax.get(Util.api.export_expense_group, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.config.modal = false;
            this.$emit("done");
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      }
    }
  }
</script>
